module.exports = __webpack_public_path__ + "img/nodata.30003060.svg";